export default {
    ageVerificationRequired: 'Age Verification Required',
    bankWire: 'Bank wire transfer',
    choosePackage: 'Choose a package',
    chooseProvider: 'Choose a payment provider',
    continue: 'Continue',
    /** the Continue button's headline: `Continue · 550 Tokens for $49.99` */
    continueSummary: 'Continue · {volume} Tokens for {price}',
    formFailedToLoad: 'Click here if the form fails to load',
    hideSmallerPackages: 'Hide smaller packages',
    perToken: '/ token',
    /** the per-token line with a row note: `$0.15 / token · CCBill only` */
    perTokenWithNote: '{perToken} · {note}',
    /** e.g. `CCBill only` */
    processorOnly: '{processor} only',
    quickBuy: 'Quick Buy',
    secureCheckoutWith: 'Secure checkout with',
    smallerPackage: 'Smaller package',
    smallerPackages: 'Smaller Token Packages',
    tokens: 'Tokens',
    /** no package on offer (not a restriction) */
    unavailable: {
        title: 'Token Packages Unavailable',
        body: 'There are no Token packages available for your account right now. If you have any questions, please',
        contactSupport: 'contact support',
        bankWirePrefix: 'You can still purchase Tokens by',
        bankWireLink: 'bank wire transfer',
    },
}
